import { useCallback } from 'react';
import { useProxyData } from '../contexts/ProxyDataContext';
import { useEscalationContact } from '../contexts/EscalationContactContext';
import { proxyNowStamp } from '../data/mockProxyJobs';

const MANAGER = 'ict-manager@betanxt.com';

// Escalate a job to the Proxy/ICT manager (or their backup while they're
// out, per the Admin Dashboard), with an optional comment, or send it back to
// the team. Both are logged on the job, so the ticket's history shows who did what.
export function useProxyEscalation() {
  const { updateJob, appendFollowUp } = useProxyData();
  const { contact } = useEscalationContact();
  const to = contact?.routed_to;

  const escalate = useCallback((jobId: string, reason: string) => {
    updateJob(jobId, { escalatedToTeam: to?.name ?? 'ICT Manager', escalatedToUserId: to?.id ?? null, escalationReason: reason || null });
    appendFollowUp(jobId, {
      timestamp: proxyNowStamp(), author: 'ICT Associate', type: 'escalated', recipientEmail: to?.email ?? MANAGER,
      subject: `Escalated to ${to?.name ?? 'the ICT manager'}`, bodyPreview: reason || 'No comment added.', jobIds: [jobId],
    });
  }, [updateJob, appendFollowUp, to]);

  const sendBack = useCallback((jobId: string) => {
    updateJob(jobId, { escalatedToTeam: null, escalatedToUserId: null, escalationReason: null });
    appendFollowUp(jobId, {
      timestamp: proxyNowStamp(), author: to?.name ?? 'ICT Manager', type: 'escalation_returned', recipientEmail: to?.email ?? MANAGER,
      subject: 'Sent back to the team', bodyPreview: 'The manager sent this back to the team to carry on.', jobIds: [jobId],
    });
  }, [updateJob, appendFollowUp, to]);

  return { escalate, sendBack };
}
